import React, {Component} from 'react';
import classNames from 'classnames';

class AutofillTextInput extends Component {
  get refName() {
    return this.props.refName;
  }

  getLabelClassName() {
    return classNames(
      'ds-input',
      '_withSuggestions',
      this.props.labelClassName,
      {_error: this.props.error},
    );
  }

  getClassName() {
    return classNames(
      this.props.className,
    );
  }

  renderError() {
    if (this.props.error) return <i> {this.props.error} </i>;
  }

  renderLabel() {
    if (!this.props.label) return;

    return (
      <span>
        {this.props.label}
        {this.renderRequiredSymbol()}
      </span>
    );
  }

  renderRequiredSymbol() {
    if (!this.props.requiredSymbol) return;
    return <i> *</i>;
  }

  handleChange = e => {
    this.props.onChange(e);
  };
  handleKeyDown = e => {
    this.props.onKeyDown(e);
  };
  handleKeyUp = e => {
    this.props.onKeyUp(e);
  };

  renderSuggestions = () => {
    if (this.props.suggestions.length === 0) {
      return;
    }
    return (
      <div className="ds-card">
        {this.props.suggestions.map(suggestion => {
          return this.props.renderSuggestionItem(
            suggestion,
            this.props.handleSuggestionSelect,
          );
        })}
      </div>
    );
  };

  render() {
    return (
      <label className={this.getLabelClassName()}>
        {this.renderLabel()}
        {this.renderError()}
        <input
          name={this.props.name}
          type={this.props.type}
          value={this.props.value}
          id={this.props.id}
          className={this.getClassName()}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
          onKeyUp={this.handleKeyUp}
          placeholder={this.props.placeholder}
          ref={this.refName}
          disabled={this.props.disabled}
          required={this.props.required}
          max={this.props.max}
          min={this.props.min}
          maxLength={this.props.maxLength}
          minLength={this.props.minLength}
          pattern={this.props.pattern}
          autoComplete={this.props.autoComplete}
          data-test={`${this.props.name}-field`}
        />
        <small>{this.props.tip}</small>
        {this.renderSuggestions()}
      </label>
    );
  }
}

AutofillTextInput.defaultProps = {
  onChange: () => {},
  onKeyUp: () => {},
  onKeyDown: () => {},
  onKeyPress: () => {},
  name: 'input',
  placeholder: 'Input value',
  refName: 'input',
  label: '',
  tip: '',
  disabled: false,
  required: false,
  requiredSymbol: false,
  pattern: undefined,
  suggestions: [],
  handleSuggestionSelect: () => {},
  renderSuggestionItem: () => {},
  autoComplete: 'on',
};

export default AutofillTextInput;



// WEBPACK FOOTER //
// ./src/features/shared/components/forms/AutofillTextInput.js